import { render, staticRenderFns } from "./GoalSettingBehaviourChangeGoalStatus.vue?vue&type=template&id=1abfe1be&scoped=true&"
import script from "./GoalSettingBehaviourChangeGoalStatus.vue?vue&type=script&lang=js&"
export * from "./GoalSettingBehaviourChangeGoalStatus.vue?vue&type=script&lang=js&"
import style0 from "./GoalSettingBehaviourChangeGoalStatus.vue?vue&type=style&index=0&id=1abfe1be&lang=scss&scoped=true&"
import style1 from "./GoalSettingBehaviourChangeGoalStatus.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfe1be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
